export const REQUEST_CREATED_MODAL_COMMISSION_ITEMS = [{ commissionsName: "Withdrawal fee:", commissionsValue: "" }];
